"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MppShortcut = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const MppShortcutSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "M21.147 6.5 17 2.354V6.25c0 .138.113.25.25.25z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.5 10.204A9 9 0 0 1 11 18a8.96 8.96 0 0 1-.935 4H21.25a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#8BBF8A",
    fillRule: "evenodd",
    d: "M10.25 12h7.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25m0 2h7.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25m4 1h5.25v1h-5.25a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25M12 17.75a.25.25 0 0 0 .25.25h5.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-5.5a.25.25 0 0 0-.25.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "m17.073 1.72 4.707 4.707c.142.142.22.33.22.53V21.75a.75.75 0 0 1-.75.75H9.796q.142-.245.269-.5H21.25a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v7.954a9 9 0 0 0-.5-.268V2.25a.75.75 0 0 1 .75-.75h9.793c.199 0 .39.08.53.22m4.073 4.78L17 2.354V6.25a.25.25 0 0 0 .25.25z",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#C8C6C4",
    fillRule: "evenodd",
    d: "M10.97 18.75a9 9 0 0 1-.14 1h8.42a1 1 0 0 0 1-1v-8.5a1 1 0 0 0-1-1h-11v2.274q.547.529 1 1.142V10.25h10v8.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#31752F",
    fillRule: "evenodd",
    d: "M2 9v-.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.014q.015-.248.014-.5a9 9 0 0 0-9-9",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#F9F7F7",
    fillRule: "evenodd",
    d: "M9.57 13.131q.086-.102.155-.216a1.96 1.96 0 0 0 .275-1.04 1.73 1.73 0 0 0-.56-1.375 2.38 2.38 0 0 0-1.605-.5H6.127q.761.394 1.43.92h.108c.755 0 1.13.34 1.13 1a1 1 0 0 1-.004.174q.427.49.78 1.037",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })]
});
const MppShortcut = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: MppShortcutSvg
}));
exports.MppShortcut = MppShortcut;